import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AlertService } from 'src/app/services/common/alert.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { SharedService } from 'src/app/services/shared.service';
import { User } from 'src/app/model/User';

import { HttpClientModule } from '@angular/common/http'; 
import { ApiResponse } from 'src/app/model/apiresponse';
import { UserModel } from 'src/app/model/UserModel';
import { ActiveSessions } from 'src/app/model/activeSessions';
import { AccountService } from 'src/app/services/account.service';
//import { HttpModule } from '@angular/http';
import { BnNgIdleService } from 'bn-ng-idle';
import { environment } from 'src/environments/environment.prod';
import  Swal  from 'sweetalert2'




@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  model : any={};    
  vatPop='firstTime';
  showModel=false;
    
  errorMessage:string; 
  accountServic :any;
  

  constructor( private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: ToastrService,
    private accountService: AccountService,
    private bnIdle: BnNgIdleService,
    private sharedService : SharedService
    
    ) {
      this.accountServic=accountService;
     if (this.authenticationService.isLoggedIn()) 
     { 
       
        this.router.navigate(['/dashboard']);
       
      }

  }

  ngOnInit() {

    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
  });

  // get return url from route parameters or default to '/'
  this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
}

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }



  onSubmit() 
    {

        this.submitted = true;

        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }

        this.loading = true;
       
const obj = {
  username: this.f.username.value,
  password:this.f.password.value
  
};
  ;
       
        this.authenticationService.Login(obj).subscribe(    
          data => {    
            if(data.Status==1)    
            {       

              this.loading = false;
              var defaultp :boolean = data.Result.DefaultPassword ;
              if(data.Result.DefaultPassword == true)
              {
                let userModel  : UserModel = this.parseString(data.Result);
                sessionStorage.setItem("currentUser",JSON.stringify(userModel));
                console.log('loging 2');
                console.log(userModel);
             
               this.alertService.success('Authentication successful'); 
              //  if(localStorage.getItem("vat")!='firstTime'){
              //   this.SwalMode();
              //   localStorage.setItem("vat","firstTime");
 
              //  }
                
             //  localStorage.setItem("ACCESS_TOKEN", data.data.token);
               //localStorage.setItem("currentUser",JSON.stringify(userModel));

             
           

              // show wizard
                this.router.navigate(['/welcome']); 

              }
              else
              {
               
                this.alertService.success('Authentication successful'); 
                let userModel  : UserModel =this.parseString(data.Result) ;
                
              //  localStorage.setItem("ACCESS_TOKEN", data.data.token);
              this.sharedService.watchingUserActivity();

                localStorage.setItem("currentUser",JSON.stringify(userModel));
             
                if(userModel.NINStatus=="" || userModel.NINStatus==null){
                this.router.navigate(['/nin']);  

                 }
                 else{
               this.router.navigate(['/dashboard']);  

                }
              
              }
               
             
            }    
            else{   
              this.loading = false;
              //this._notificationservice.error("Error logging in"); 
              
                  
              this.errorMessage = data.Message;  
              if(this.errorMessage=='No Access'){
                this.alertService.error("No Access");

              }
              else{
                this.alertService.error("Invalid User/Password");
              }
            
            }    
          },     
          error => {    
             
            this.loading = false;  
          //  this._notificationservice.error("Error logging in"); 

            this.errorMessage = error.message; 
            
            this.alertService.error(environment.GenericErrorMsg); 
          });    
      } 
      parseString(data: any) : any {
        
          
        return new UserModel(data.UserID, data.UserName,data.PasswordHash,data.FirstName, data.LastName,data.SecurityStamp,data.Discriminator,
          data.i_Customer,data.AccountID,data.i_Account, data.DefaultPassword, data.OperatorID, data.EntryDate, data.UserType, data.Balance, data.MobilePhone, data.KycStatus,data.NINStatus, data.NIN );
      }   
}